import Entity from "../../../class/abstract/Entity";
import moment from "moment";

class Contract extends Entity {
    store_id = null;
    store = null;
    license_id = null;
    license = null;
    licenseType = null;
    begin = null;
    end = null;
    commitment = null;
    billingType = null;
    completionDeadline = null;
    contract_file = null;
    discountValue = null;
    discountType = null;
    discountDuration = null;
    amountInclTax = null;
    amountInclTaxUndiscounted = null;
    amountExclTax = null;
    amountExclTaxUndiscounted = null;
    amountTax = null;
    amountTaxUndiscounted = null;
    discountAmount = null;
    vat = null;
    assigned_to_id = null;
    assigned = null;
    creator_id = null;
    creator = null;
    terminated_on = null;
    terminated_by = null;
    terminator = null;
    terminationReason = null;
	state = null;

    constructor(datas = {}) {
        super(datas);
        this.setAttributes(datas);
    }

    setAttributes(datas) {
        let keys = Object.keys(this);
        let key = "";
        let i = 0;

        for(i in keys) {
            key = keys[i];

            if (datas[key] !== undefined)
                Reflect.set(this, key, datas[key]);
        }

		this.setState();
    }
	setState() {
		if (this.end !== null && moment() >= moment(this.end)) {
			this.state = "STANDBY";
		}
		else if (this.terminated_on !== null) {
			this.state = moment() < moment(this.terminated_on) ? "TERMINATING" : "TERMINATED";
		}
		else if (this.contract_file == null && moment() < moment(this.completionDeadline)) {
			this.state = "WAITING";
		}
		else if (this.contract_file == null && moment() >= moment(this.completionDeadline)) {
			this.state = "INCOMPLETE";
		}
		else if (this.contract_file !== null && moment() < moment(this.begin)) {
			this.state = "READY";
		}
		else {
			this.state = "ACTIVE";
		}
	}
}

export default Contract;
